import axios from "axios";

export default {
  async create(formData) {
    return axios.post(`/owner-settlements`, formData);
  },
  async findAll() {
    return axios.get(`/owner-settlements`);
  },
  async getAttachementPdf(formData) {
    return axios.get(`/owner-settlements/${formData.id}/pdf-attachment`, { responseType: 'arraybuffer' });
  },
  async PDFPreview(formData) {
    return axios.post(`/owner-settlements/pdf-preview`, formData, { responseType: 'arraybuffer' });
  },
  async delete({ id }) {
    return axios.delete(`/owner-settlements/${id}`);
  },
};